module.exports = __webpack_public_path__ + "39012a5b28c9bb4fc883d1cc1733b061.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/owl-hoots/barn_owl_hoot.mp3
// module id = 3268
// module chunks = 0